<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Extras</h4>
          <p class="category">
            These are the Extras that are available to Customers booking this
            Departure.
          </p>
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click.prevent="assignExtra"
          >
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top"
              >Assign an Extra<br />to this Departure</md-tooltip
            >
          </md-button>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <template v-if="extraDrafts.length">
        <div
          class="md-layout optional-extra-wrapper"
          v-for="extra in extraDrafts"
          :key="extra.title"
        >
          <div class="md-layout-item md-size-50">
            <h6>{{ extra.title }}</h6>
          </div>
          <div class="md-layout-item md-size-50 text-right">
            <md-switch v-model="extra.price_sync">Synced with Parent</md-switch>
          </div>

          <div class="md-layout-item md-size-33">
            <md-field class="md-form-group" slot="inputs">
              <md-icon
                ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
              ></md-icon>
              <label>GBP</label>
              <md-input
                :disabled="extra.price_sync"
                v-model="extra.prices.gbp"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field class="md-form-group" slot="inputs">
              <md-icon
                ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
              ></md-icon>
              <label>EUR</label>
              <md-input
                :disabled="extra.price_sync"
                v-model="extra.prices.eur"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33">
            <md-field class="md-form-group" slot="inputs">
              <md-icon
                ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
              ></md-icon>
              <label>USD</label>
              <md-input
                :disabled="extra.price_sync"
                v-model="extra.prices.usd"
                type="text"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50">
            <md-switch :disabled="extra.price_sync" v-model="extra.compulsory"
              >Compulsory</md-switch
            >
          </div>
          <div class="md-layout-item md-size-50 text-right">
            <md-button
              class="md-just-icon md-simple md-success"
              @click.prevent="updateExtra(extra)"
            >
              <md-icon>save</md-icon>
              <md-tooltip md-direction="top">Update this Extra</md-tooltip>
            </md-button>
            <md-button
              class="md-just-icon md-simple md-danger"
              @click.prevent="removeExtra(extra)"
            >
              <md-icon>remove_circle</md-icon>
              <md-tooltip md-direction="top">Remove this Extra</md-tooltip>
            </md-button>
          </div>
        </div>
      </template>

      <md-empty-state v-else md-label="Nothing to Show">
        <md-button class="md-primary md-raised" @click="assignExtra"
          >Assign an Extra</md-button
        >
      </md-empty-state>
    </md-card-content>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Assign an Extra</md-dialog-title>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addExtra)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label for="title">Select an Extra</label>
                <md-select v-model="selectedExtra" name="extra" id="extra">
                  <md-option
                    v-for="availableExtra in availableExtras"
                    :value="availableExtra.id"
                    :key="availableExtra.id"
                    >{{ availableExtra.title }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary" @click="cancel">Cancel</md-button>
            <md-button type="submit" class="md-primary">Assign</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </md-card>
</template>

<script>
import tourApi from "@/services/api/tour";
import { mapGetters } from "vuex";

export default {
  props: ["departure"],

  data() {
    return {
      showDialog: false,
      availableExtras: [],
      selectedExtra: null,
      extraDrafts: []
    };
  },

  methods: {
    getExtras() {
      this.$store.dispatch("departures/fetchExtras", this.departure);
    },

    getAvailableExtras() {
      tourApi
        .getExtras(this.departure.tour)
        .then(response => {
          this.availableExtras = response.data;
        })
        .catch();
    },

    removeExtra(extra) {
      this.$store
        .dispatch("departures/removeExtra", {
          departure: this.departure,
          extra
        })
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: "The Extra has been removed.",
            icon: "cancel",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        })
        .catch(() => {});
    },

    assignExtra() {
      this.showDialog = true;
    },

    cancel() {
      this.showDialog = false;
      this.selectedExtra = null;
    },

    addExtra() {
      this.$store
        .dispatch("departures/assignExtra", {
          departure: this.departure,
          extraId: this.selectedExtra
        })
        .then(() => {
          this.cancel();
        })
        .catch(() => {});
    },

    updateExtra(extra) {
      this.$store
        .dispatch("departures/updateExtra", {
          departure: this.departure,
          extra
        })
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: "The Extra has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(() => {});
    }
  },

  mounted() {
    this.getExtras();
    this.getAvailableExtras();
  },

  watch: {
    "departure.id"(nextId, prevId) {
      if (nextId && nextId !== prevId) {
        this.getExtras();
        this.getAvailableExtras();
      }
    },
    extras: {
      handler(nextExtras) {
        this.extraDrafts = Array.isArray(nextExtras)
          ? nextExtras.map(extra => structuredClone(extra))
          : [];
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters("departures", ["extras"])
  }
};
</script>
<style lang="scss" scoped>
.optional-extra-wrapper {
  border: 1px solid #ddd;
  border-radius: 7px;
  background-color: #f6f6f6;
  margin-bottom: 1em;
}
</style>
